import { useState } from 'react';
import { Button } from '@tryhackme/thm-ui-components';
import { ModalLayout } from '../../../modal';
import { StyledLoadingSpinner, StyledSaveTaskModalText } from './save-task-modal.styles';
export const SaveTaskModal = ({
  handleAction,
  isSaveButtonEnabled,
  isSavingChanges
}: {
  handleAction: () => Promise<void>;
  isSaveButtonEnabled: boolean;
  isSavingChanges: boolean;
}) => {
  const [open, setOpenChange] = useState(false);
  const handleSaveChangesAction = async () => {
    await handleAction();
    setOpenChange(false);
  };
  return <ModalLayout open={open} openChange={setOpenChange} triggerButtonVariant="solid" triggerButtonColor="primary" triggerText="Save changes" modalTitleText="Save changes" closeButtonText="Cancel" showWarnBox={false} isTriggerButtonDisabled={isSaveButtonEnabled} actionElement={
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  <Button onClick={handleSaveChangesAction} disabled={isSavingChanges}>
          {isSavingChanges && <StyledLoadingSpinner color="#151C2B" />}
          {isSavingChanges ? 'Saving changes...' : 'Save changes'}
        </Button>} data-sentry-element="ModalLayout" data-sentry-component="SaveTaskModal" data-sentry-source-file="save-task-modal.tsx">
      <StyledSaveTaskModalText data-sentry-element="StyledSaveTaskModalText" data-sentry-source-file="save-task-modal.tsx">
        Are you sure you want to save your changes and update this room?
      </StyledSaveTaskModalText>
    </ModalLayout>;
};